<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card title="车辆费用信息">
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <Accident ref="accident" @getOtherFormVal="getOtherFormVal" />
      <DetailForm ref="detailForm" @getOtherFormVal="getOtherFormVal" />
      <Receipt ref="receipt" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Accident from './accident';
import DetailForm from './detail/detail';
import Receipt from './receipt';
import SubBtnBox from 'components/subBtnBox';
import {
  carCostDetail,
  doSaveVehicleFee,
} from 'api/cost';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Accident,
    DetailForm,
    Receipt,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/car/car/edit',
      formComponents: ['baseForm', 'accident', 'detailForm', 'receipt'],
      editParams: {
        busiType: -1,
      },

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        costType: '',
        orgId: '',
        isNeedBill: '',
        serviceName: '',

        // 这个不知道判断逻辑是什么，暂时不判断
        receUserId: '',
        selectedLIds: '',
      },
    };
  },
  watch: {
    '$route.query.vehicleFeeType': async function () {
      await this.$refs.baseForm.getList();
    },
  },
  computed: {
    detailParams () {
      return {
        payId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: carCostDetail,
    editApi: doSaveVehicleFee,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      console.log('对比参数', compareParams);
      if (Array.isArray(compareParams.selectedLIds)) {
        if (compareParams.selectedLIds.length) {
          // 这个不知道判断逻辑是什么，暂时不判断
        } else {
          compareParams.selectedLIds = '[]';
        }
      }
    },
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
    handleParams (params) {
      params.vehicleFeeType = this.$route.query.vehicleFeeType;
      if (Number(params.vehicleFeeType) === 2) {
        // 订单报销的时候多传这个字段会报错
        delete params.costType;
      }
      if (!params.vehicleFeeFileDetails || !params.accidentInfo) {
        return;
      }
      let vehicleFeeFileDetails = params.vehicleFeeFileDetails;
      if (typeof vehicleFeeFileDetails === 'string') {
        vehicleFeeFileDetails = JSON.parse(vehicleFeeFileDetails);
      }

      let accidentInfo = params.accidentInfo;
      if (typeof params.accidentInfo === 'string') {
        accidentInfo = JSON.parse(accidentInfo);
      }
      const item = vehicleFeeFileDetails[vehicleFeeFileDetails.length - 1];
      if (!item) {
        return;
      }
      // 复制旧版代码
      item.plateNumber = accidentInfo.plateNumber || item.plateNumber;
      item.accidentStateName = accidentInfo.accidentStateName || item.accidentStateName;
      item.insuranceCompany = accidentInfo.insuranceCompany || item.insuranceCompany;
      item.insuranceUserName = accidentInfo.insuranceUserName || item.insuranceUserName;
      item.insuranceStartDate = accidentInfo.insuranceStartDate || item.insuranceStartDate;
      item.insuranceEndDate = accidentInfo.insuranceEndDate || item.insuranceEndDate;
      item.insuranceNumber = accidentInfo.insuranceNumber || item.insuranceNumber;
      item.accidentTime = accidentInfo.accidentTime || item.accidentTime;
      item.reportTime = accidentInfo.reportTime || item.reportTime;
      item.responsibilityAttributionName = accidentInfo.accidentResponsibility || item.responsibilityAttributionName;
      item.isVehicleDamageName = accidentInfo.isVehicleDamageName || item.isVehicleDamageName;
      item.isOtherAccidentName = accidentInfo.isOtherAccidentName || item.isOtherAccidentName;
      item.isGoodsDamageName = accidentInfo.isGoodsDamageName || item.isGoodsDamageName;
      item.isRoadDamageName = accidentInfo.isRoadDamageName || item.isRoadDamageName;
      item.isWoundingName = accidentInfo.isWoundingName || item.isWoundingName;
      item.repairServiceName = accidentInfo.repairServiceName || item.repairServiceName;
      item.repairServiceAmt = accidentInfo.repairServiceAmt || item.repairServiceAmt;
      item.repairServiceAddress = accidentInfo.repairServiceAddress || item.repairServiceAddress;
      item.repairServiceTel = accidentInfo.repairServiceTel || item.repairServiceTel;
      item.isRepairCompleteName = accidentInfo.isRepairCompleteName || item.isRepairCompleteName;
      item.busiType = accidentInfo.certificatesInsuranceType || item.certificatesInsuranceType;

      item.vid = accidentInfo.id ? accidentInfo.id.toString() : (`${item.vid || ''}` || '');
      item.id = accidentInfo.id ? accidentInfo.id.toString() : (`${item.id || ''}` || '');
      item.cid = accidentInfo.cid ? accidentInfo.cid.toString() : (`${item.cid || ''}` || '');
      item.payId = accidentInfo.payId ? accidentInfo.payId.toString() : (`${item.payId || ''}` || '');

      if (Number(params.costType) !== 2009) {
        // 不是 事故 类型，不需要提交这个字段
        delete params.accidentInfo;
      }
      params.isCheckAuthVehicle = 1;
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
